export default __webpack_public_path__ + "static/media/bp6.9ef21961.png";